import type { InputHTMLAttributes, ReactNode } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: ReactNode;
  error?: string | null;
}

export function FormField({ label, hint, error, id, className, ...rest }: Props): React.ReactElement {
  const inputId = id ?? rest.name;
  return (
    <label htmlFor={inputId} className="block">
      <span className="mb-1 block text-sm font-medium text-[var(--color-header)]">{label}</span>
      <input
        id={inputId}
        {...rest}
        className={[
          'block w-full rounded-[var(--radius-button)] border border-[var(--color-border)] bg-white px-3 py-2.5 text-[15px] text-[var(--color-body)] outline-none transition focus:border-[var(--color-t3-blue)] focus:ring-2 focus:ring-[var(--color-t3-blue)]/30',
          className ?? '',
        ].join(' ')}
      />
      {hint && !error && <span className="mt-1 block text-xs text-[var(--color-muted)]">{hint}</span>}
      {error && <span className="mt-1 block text-xs text-[var(--color-danger)]">{error}</span>}
    </label>
  );
}
